import{Component} from '@angular/core';
import {NgbPanelChangeEvent} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector:'protected',
    template:'<div> Protected  debugger;  </div>'
})

export class ProtectedComponent{
      
}